// src/modules/settings/Theme.tsx
const Theme = () => {
  return (
    <div className="p-6 text-white">
      <h2 className="text-xl font-semibold mb-4">Theme Settings</h2>
      <div className="space-y-4">
        <p className="text-gray-400">Theme customization options will be available here.</p>
      </div>
    </div>
  );
};

export default Theme;
